import withLazyLoading from '../../hoc/withLazyLoading';
import { createCrumbHandle } from '../../utilities/auth';
import withPostHogTracker from '../../composeRouter';

const AlertTaskConfig = withLazyLoading(() => import('../../pages/AlertTaskConfig'));
const AlertTaskMaster = withLazyLoading(() => import('../../pages/AlertTaskMaster'));
const ManualAlertConfig = withLazyLoading(() => import('../../pages/ManualAlertConfig'));
const Maintenance = withLazyLoading(() => import('../../pages/Maintenance'));
const EquipmentControl = withLazyLoading(() => import('../../pages/EquipmentControl'));
const CheckIn = withLazyLoading(() => import('../../pages/CheckIn'));
const Ticketsv2 = withLazyLoading(() => import('../../pages/Ticketsv2'));
const CreateTaskPage = withLazyLoading(
  () => import('../../components/TaskTemplate/pages/CreateTaskPage')
);
const TaskTemplateList = withLazyLoading(
  () => import('../../components/TaskTemplate/components/TaskTemplateList')
);
const ResponsiveTaskView = withLazyLoading(
  () => import('../../components/OperatorTask/components/ResponsiveTaskView')
);
const WorkflowCreator = withLazyLoading(
  () => import('../../components/Workflow/components/WorkflowCreator')
);
const EditSkill = withLazyLoading(() => import('../../components/EditSkill/components/SearchSkill'));
const RosterCreator = withLazyLoading(
  () => import('../../components/RoasterCalendar/components/RosterCreator')
);
const RoasterPlanningList = withLazyLoading(
  () => import('../../components/RoasterPlanning/components/RoasterPlanningList')
);
const WorkflowList = withLazyLoading(
  () => import('../../components/Workflow/components/WorkflowList')
);


const taskRoutes = [
  {
    path: '/taskTemplates',
    handle: createCrumbHandle('Fixed Tasks Configuration'),
    children: [
        { 
            index: true,
            element: <TaskTemplateList />,    
            // authz-v2 TODO: TaskTemplate_View_R — gate server-side / useCan at component level
        },
        {
            path: 'taskTemplate/:taskTemplateId?',
            element: <CreateTaskPage />,    
            // authz-v2 TODO: TaskTemplate_Manage_A — gate server-side / useCan at component level
            handle: createCrumbHandle('Create Task'),
          },
    ]
  },
  {
    path: '/taskListPage',
    element: withPostHogTracker(<ResponsiveTaskView />),    
    // loader: validatePermission('Tasks_View_R'),
    handle: createCrumbHandle('Tasks'),
  },
  {
    path: '/alertTasksConfig/:id',
    element: <AlertTaskConfig />,    
    // loader: validatePermission('AlertTask_Configuration_W'),
    handle: createCrumbHandle('Alert Tasks Configuration'),
  },
  {
    path: '/alertTaskMaster',
    element: <AlertTaskMaster />,    
    // authz-v2 TODO: AlertTask_Templating_WE — gate server-side / useCan at component level
    handle: createCrumbHandle('Alert Task Master'),
  },
  {
    path: '/manualAlertsConfig/:id',
    element: <ManualAlertConfig />,    
    // loader: validatePermission('ManualTickets_Configuration_WE'),
    handle: createCrumbHandle('Manual Alerts Configuration'),
  },
  {// @obsolete
    path: '/maintenance/:id',
    element: withPostHogTracker(<Maintenance />),    
    handle: createCrumbHandle('Maintenance'),
  },
  { // @obsolete
    path: '/equipmentControl/:id',
    element: withPostHogTracker(<EquipmentControl />),    
    handle: createCrumbHandle('Equipment Control'),
  },
  {
    path: '/checkIn',
    element: withPostHogTracker(<CheckIn />),    
    // authz-v2 TODO: Check-in_Usage_WE — gate server-side / useCan at component level
    handle: createCrumbHandle('Check-In'),
  },
  {
    path: '/tickets',
    element: withPostHogTracker(<Ticketsv2 />),    
    // loader: validatePermission('AutoGenerateTickets_View_R'),
    handle: createCrumbHandle('Tickets'),
  },
  {
    path: '/workflows',
    handle: createCrumbHandle('Workflows'),
    children: [
        {
            index: true,
            element: <WorkflowList />,    
            // authz-v2 TODO: Workflow_View_R — gate server-side / useCan at component level
        },
        {
            path: 'editWorkflow/:workflowId?',
            element: <WorkflowCreator />,    
            // authz-v2 TODO: Workflow_Manage_A — gate server-side / useCan at component level
            handle: createCrumbHandle('Create Workflow'),
          },
    ]
  },
  {
    path: '/skill',
    element: <EditSkill />,    
    // authz-v2 TODO: SkillManagement_Manage_A — gate server-side / useCan at component level
    handle: createCrumbHandle('Skills'),
  },
  {
    path: '/rosterPlan',
    handle: createCrumbHandle('Rosters'),
    children: [
        {
            index: true,
            element: <RoasterPlanningList />,    
            // loader: validatePermission('RosterManagement_View_R'),
        },
        {
            path: 'roster/:rosterId?',
            element: <RosterCreator />,    
            // loader: validatePermission('RosterManagement_Manage_A'),
            handle: createCrumbHandle('Create Roster'),
          },
    ]
  },
];

export default taskRoutes;